import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

const LOCALITIES = ["Golf Course Road", "DLF Phase 2", "Sector 42", "Sohna Road", "MG Road", "Cyber City"];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-6 py-20 lg:px-12">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <LogoMark size={44} />
              <p className="font-serif text-3xl text-bone">Gurgaon Estates</p>
            </div>
            <p className="mt-6 max-w-sm text-sm font-light leading-relaxed text-smoke">
              A curated marketplace and brokerage for Gurgaon's most exceptional residences — where developers,
              agents, and buyers meet under one standard of quality.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Marketplace</p>
            <ul className="mt-6 space-y-3 text-sm font-light text-smoke">
              <li><Link className="transition-colors hover:text-bone" to="/listings?listing_type=sale" data-testid="footer-buy-link">Residences for Sale</Link></li>
              <li><Link className="transition-colors hover:text-bone" to="/listings?listing_type=rent" data-testid="footer-rent-link">Residences for Lease</Link></li>
              <li><Link className="transition-colors hover:text-bone" to="/register?role=builder" data-testid="footer-builder-link">For Developers</Link></li>
              <li><Link className="transition-colors hover:text-bone" to="/register?role=agent" data-testid="footer-agent-link">For Brokers</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Localities</p>
            <ul className="mt-6 grid grid-cols-2 gap-3 text-sm font-light text-smoke">
              {LOCALITIES.map((l) => (
                <li key={l}>
                  <Link className="transition-colors hover:text-bone" to={`/localities/${l.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-20 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">© 2026 Gurgaon Estates · Gurugram, Haryana</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">Curation · Verification · Closure</p>
        </div>
      </div>
    </footer>
  );
}
